import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
//import Modal from 'react-modal';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './DetailPage.css';
import axios from 'axios';

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import api from '../api';


// Import des icônes FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faWarehouse, faHammer, faMapMarkerAlt, faStar, faUser, faFileAlt, faBed, faCouch, faBath, faUserFriends, faCity, faBuilding, faGlobe, faTag, faDollarSign, faTools, faCalendarCheck, faInfoCircle, faClipboardList, faCogs } from '@fortawesome/free-solid-svg-icons';


//Modal.setAppElement('#root'); // Pour l'accessibilité

function DetailsVente() {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {

      const fetchSaleProperty = async () => {
        try {
          const response = await api.get(`/sales/${id}`);
          setProperty(response.data);
          setLoading(false);
        } catch (err) {
          console.error('Erreur lors de la récupération de la vente:', err);
          setError("Erreur lors de la récupération de la vente");
          setLoading(false);
        }
      };
      fetchSaleProperty();
  }, [id]);
  
  if (loading) return <div>Chargement...</div>;
  if (error) return <div>{error}</div>;
  if (!property) return <div>Vente non trouvée</div>;

  const openModal = (index) => {
  setPhotoIndex(index);
  setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const getCategoryIcon = (category) => {
      switch (category) {
          case 'Terrains': return faMapMarkerAlt;
          case 'Appartements': return faBuilding;
          case 'Maisons': return faHome;
          case 'Champs': return faWarehouse;
          case 'Matériel BTP': return faHammer;
          default: return faTag;
      }
  };

  // Juste avant le return()
  // Gérer les deux cas : images en base64 ou images avec URL Cloudinary
  const images = property.images.map(image => {
    // Cas Cloudinary avec une URL directe
    if (typeof image === 'object' && image.url) return image.url;

    // Cas chaîne string (ancienne base64 ou erreur)
    if (typeof image === 'string') {
      if (image.startsWith('http')) return image; // URL déjà valide
      return `data:image/jpeg;base64,${image}`;
    }

    return ''; // sécurité
  });

  // Pour le lightbox
  const slides = images.map((img) => ({
    src: img,
  }));

  return (
    <div className="detail-page-container">
      <div className="detail-main-content">
        <h1>{property.title}</h1>
        <p className="property-icon">
          <i className="fas fa-map-marker-alt"></i> {property.localisation.name}
        </p>

        <div className="detail-carousel">
          <Carousel className="detail-page-carousel" showThumbs={true} infiniteLoop={true}>
            {images.map((image, index) => (
              <div key={index} onClick={() => openModal(index)}>
                {/*<img src={`data:image/jpeg;base64,${image}`} alt={`Slide ${index + 1}`} style={{ cursor: 'pointer' }} />*/}
                <img src={image} alt={`Slide ${index + 1}`} />
              </div>
            ))}
          </Carousel>
        </div>

        <Lightbox
          open={isOpen}
          close={closeModal}
          index={photoIndex}
          slides={slides}
        >

          <button onClick={closeModal} className="modal-close-button">Fermer</button>
          <h2>{property.title}</h2>
          <Carousel className="detail-page-carousel" selectedItem={photoIndex} showThumbs={true} infiniteLoop={true}>
            {images.map((image, index) => (
              <div key={index}>
                {/*<img src={`data:image/jpeg;base64,${image}`} alt={`Slide ${index + 1}`} />*/}
                <img src={image.startsWith('data:image') ? image : `data:image/jpeg;base64,${image}`} alt={`Slide ${index + 1}`} />
              </div>
            ))}
          </Carousel>
        </Lightbox>

        <div className="detail-section detail-description">
            <h2>
                <FontAwesomeIcon icon={faInfoCircle} /> Description
                <span style={{ fontSize: '16px', color: '#0071c2', marginLeft: '15px' }}>
                (Réf: {property.details.reference})
                </span>
            </h2>
            <div className="rich-description" dangerouslySetInnerHTML={{ __html: property.description }} />
        </div>


        <div className="detail-section detail-address">
          <h2><FontAwesomeIcon icon={faMapMarkerAlt} /> Adresse</h2>
          <div className="detail-row">
            <p><FontAwesomeIcon icon={faCity} /> Ville : {property.localisation.city}</p>
            <p><FontAwesomeIcon icon={faBuilding} /> Quartier : {property.localisation.district}</p>
          </div>
          <div className="detail-row">
            <p><FontAwesomeIcon icon={faGlobe} /> Pays : {property.localisation.country}</p>
            <p><FontAwesomeIcon icon={faBuilding} /> Nom : {property.localisation.name}</p>
          </div>
        </div>

        <div className="detail-section detail-info">
          <h2><FontAwesomeIcon icon={faClipboardList} /> Détails</h2>
          <div className="detail-row">
            <p><FontAwesomeIcon icon={faTag} /> Status : {property.status}</p>
            <p><FontAwesomeIcon icon={faDollarSign} /> Prix : {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(property.details.price)}</p>
          </div>
          <div className="detail-row">
            <p><FontAwesomeIcon icon={getCategoryIcon(property.category)} /> Catégorie : {property.category}</p>
            {property.details.area && <p><FontAwesomeIcon icon={faCogs} /> Superficie : {property.details.area}</p>}
          </div>
        </div>

        <div className="detail-section detail-amenities">
            <h2><FontAwesomeIcon icon={faCogs} /> Autres</h2>
            <ul>
            {property.autres.map((amenity, index) => (
                <li key={index}><FontAwesomeIcon icon={faTools} /> {amenity}</li>
            ))}
            </ul>
        </div>

      </div>

      <div className="detail-contact-container">

        <div className="detail-contact-form">
          <h2><FontAwesomeIcon icon={faCalendarCheck} /> Programmer une visite?</h2>
          <form>
            <input type="text" placeholder="Nom" />
            <input type="email" placeholder="Email" />
            <input type="tel" placeholder="Téléphone" />
            <textarea placeholder={`Je suis intéressé par votre annonce [ ${property.title} ]`} />
            <button type="submit">Envoyer Un Email</button>
          </form>
        </div>

        <div className="detail-reservation">
          <h2>{property.details.price} CFA par nuit</h2>
          <div className="stars">
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
            <FontAwesomeIcon icon={faStar} />
          </div>
          <div className="reservation-dates">
            <label>Date :</label>
            <div className="date-picker">
              <p>Arrivée</p>
              <input type="date" placeholder="Arrivée" />
              <span>➔</span>
              <p>Départ</p>
              <input type="date" placeholder="Départ" />
            </div>
          </div>
          <div className="reservation-guests">
            <label>Voyageur(s) :</label>
            <div className="guest-picker">
              <button><FontAwesomeIcon icon={faUser} /> 1 Adulte, 0 Enfant</button>
            </div>
          </div>
          <div className="reservation-price">
            <div className="price-item">
              <span>880 600 CFA /Mois * Nbre de nuits :</span>
              <strong>880 600 CFA</strong>
            </div>
            <div className="price-item">
              <span>FRAIS SERVICE :</span>
              <strong>3%</strong>
            </div>
            <div className="price-item total">
              <span>TOTAL :</span>
              <strong>0 CFA</strong>
            </div>
          </div>
          <button 
                    className="btn-reservation" 
                    onClick={() => {
                      window.location.href = "https://wa.me/221776759906";
                    }}
                  >
                    Réserver
                  </button>
          <p className="reservation-note">Vous ne serez débité que si vous confirmez</p>
        </div>

      </div>

    </div>
  );
}

export default DetailsVente;